import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as components from './components';
import * as constants from './constants';

export default {
  actions,
  actionTypes,
  components,
  constants,
}


// WEBPACK FOOTER //
// ./src/modules/events/index.js